import { Component, OnInit, Input } from "@angular/core";
import { PortalService } from "../../services/portal-service.service";
import { AuthService } from "../../services/auth.service";
import { Contracts } from "../../models/contracts";
import { UserDetails } from "../../models/user";
import { LogService } from "../../services/log.service";

@Component({
  standalone: false,
  selector: "app-contract-summary",
  templateUrl: "./contract-summary.component.html",
  styleUrls: ["./contract-summary.component.scss"],
})
export class ContractSummaryComponent implements OnInit {
  @Input() contract: Contracts;
  @Input() hideAddress: false;
  @Input() showReturns: false;

  userData = new UserDetails();
  showCustomerInfo = false;
  loadingCustomerInfo = false;
  customerInfo = null;

  constructor(
    private portalService: PortalService,
    private logService: LogService,
    private authService: AuthService,
  ) {}

  ngOnInit() {
    this.userDetails();
    this.showCustomerInfo = true;
    this.toggleCustomerInfo();
  }

  async toggleCustomerInfo() {
    this.loadingCustomerInfo = true;
    try {
      this.customerInfo = await this.portalService.getCustomerInfo(this.contract.id);
      this.loadingCustomerInfo = false;
      this.showCustomerInfo = true;
    } catch (error) {
      this.logService.log("Failed to get customer info", error);
    }
  }

  resetCustomerInfo() {
    this.showCustomerInfo = false;
    this.loadingCustomerInfo = false;
    this.customerInfo = null;
  }

  async userDetails() {
    const user = this.authService.getToken();
    let user_id = null;
    if (user) {
      user_id = this.authService.JWTDecode(user).sub;
      this.userData = await this.portalService.getUser(user_id);
    }
  }
}
